import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { BookingModel, InvoiceModel, PaymentStatus } from "../../../data/entities";
import { PaymentProcessorHandler } from "../interface";
import { PaymentService } from "../../../services/payment";
import { PaymentRequestDTO } from "../../../models";
import visa from "../../../images/creditcards/visa-512x512.svg";
import mastercard from "../../../images/creditcards/mastercard-512x512.svg";
import amex from "../../../images/creditcards/amex-512x512.svg";
import jcb from "../../../images/creditcards/jcb-512x512.svg";
import discover from "../../../images/creditcards/discover-512x512.svg";

export interface MonerisFormProps {
  invoice: InvoiceModel;
  booking: BookingModel;
  setPaymentStatus: React.Dispatch<React.SetStateAction<string|null>>
}

export const MonerisForm = forwardRef<PaymentProcessorHandler, MonerisFormProps>((props, ref) => {
  
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const paymentService = new PaymentService();

  const handleSubmit = async (event:any) => {
    event.preventDefault();
    if (!iframeRef.current) return;
    iframeRef.current.contentWindow?.postMessage("tokenize", "https://esqa.moneris.com/HPPtoken/index.php");
  }

  //WE need to listen for the iframe response for the tokenization of the customer cc
  useEffect(()=>{
    const respMsg = async (e: MessageEvent) => {
      if (!e.origin.includes("moneris.com")) return;

      try {
        const respData = JSON.parse(e.data);

        if (respData.responseCode[0] === "001") {
          const paymentReq: PaymentRequestDTO = {
            invoiceId: props.invoice.id,
            total: props.invoice.total,
            token: respData.dataKey
          }
          
          const results = await paymentService.processPaymentAsync(paymentReq);
          
          if(results.status === PaymentStatus.Posted){
            props.setPaymentStatus("succeeded");
          } else {
            props.setPaymentStatus("failed");
          }
        } else {
          props.setPaymentStatus("failed");
        }
      } catch (error) {
        console.error("Error processing payment:", error);
        props.setPaymentStatus("failed");
      }
    };
    
    window.addEventListener("message", respMsg);
    return () => window.removeEventListener("message", respMsg);
  }, [props.invoice.id, props.invoice.total, props.setPaymentStatus]);

   useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ width: "100%", margin: "0" }}>
        <div style={{ display: "flex", justifyContent: "flex-start", width: "auto", marginBottom: "1rem" }}>
          <img src={visa} alt="Visa" className="card-logo" width={43} />
          <img src={mastercard} alt="Mastercard" className="card-logo" width={43} />
          <img src={amex} alt="American Express" className="card-logo" width={43} />
          <img src={jcb} alt="JCB" className="card-logo" width={43} />
          <img src={discover} alt="Discover" className="card-logo" width={43} />
        </div>
        <iframe
          ref={iframeRef}
          title="Moneris Payment Form"
          id="monerisFrame"
          src="https://esqa.moneris.com/HPPtoken/index.php?id=htC8IDN6YX527B7&pmmsg=true&css_textbox=color:rgb(47,65,87);border-color:rgb(195,195,195);border-width:1px;padding:1rem;margin-top:2rem;border-radius:6px;box-shadow:0 2px 6px rgba(47,65,87,0.3);&css_textbox_focus=border-color:rgb(47,65,87);&css_textbox_pan=font-size:1rem;width:100%;&enable_exp=1&css_textbox_exp=font-size:1rem;width:48%;display:inline-block;margin-right:4%;&enable_cvd=1&css_textbox_cvd=font-size:1rem;width:48%;display:inline-block;&display_labels=2&exp_label=Expiration Date (MM/YY)&cvd_label=Security Code&enable_exp_formatting=1&enable_cc_formatting=1"          
          width="100%"
          height="250"
          allow="payment"
        />
      </div>
    </form>
  );
});

export default MonerisForm;